<template>
<router-view></router-view>
</template>

<script>
export default {
name: "Admin"
}
</script>

<style scoped>

</style>
